// src/contexts/vendas/NotaContext.js
import React, { createContext, useContext, useState } from 'react';
import { postData, putData, deleteData, fetchData } from '../../services/Api';
import { parseCurrency } from '../../utils/numberUtils';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import { Nota } from '../../models/vendas/Nota';

const NotaContext = createContext();

export const useNota = () => useContext(NotaContext);

export const NotaProvider = ({ children }) => {
    const [notas, setNotas] = useState([]);
    const [notaSel, setNotaSel] = useState(new Nota());
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const buildNotaPayload = (nota) => {
        const payLoad = { ...nota };

        delete payLoad.cliente;
        delete payLoad.natureza;

        if (Array.isArray(payLoad.notaItens)) {
            payLoad.notaItens = payLoad.notaItens.map((item) => {
                const notaItem = { ...item };

                delete notaItem.produto;

                return {
                    ...notaItem,
                    qtdCom: parseCurrency(notaItem.qtdCom),
                    vUnCom: parseCurrency(notaItem.vUnCom),
                    vProd: parseCurrency(notaItem.vProd),
                };
            });
        }

        return payLoad;
    };

    /*
    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                //por enquanto não precisa carregar dados das notas
                const result = await fetchData('/Nota');
                setNotas(result);
            } catch (error) {
                console.error("Erro ao buscar notas:", error);
            }
        };
        fetchDataFromAPI();
    }, []);
    */

    const buscaNotaById = async (notaId) => {
        try {
            //por enquanto não precisa carregar dados das notas
            const result = await fetchData('/Nota/GetNotaDetalhadaById',{notaId});
            return result;
        } catch (error) {
            console.error("Erro ao buscar notas:", error);
            showMessage(`Erro ao buscar notas! ${error?.message || error}`, 'danger');
        }
    };

    const buscaNotaByChave = async (chave) => {
        try {
            const result = await fetchData(`/Nota/GetByChave`, { chave });
            return result;
        } catch (error) {
            console.error("Erro ao buscar nota pela chave:", error);
            return null;
        }
    };


    const addNota = async (nota) => {
        try {

            const payLoad = buildNotaPayload(nota);

            const result = await postData('/Nota', payLoad); // Realiza o post e obtém o resultado
            
            setNotas([...notas, result]); // Atualiza a lista de notas  
            //setNota({...nota, id:result.id});//atualiza o Id da Nota

            showAlert('Nota adicionada com sucesso!');
            return result; // Retorna o resultado do post
        } catch (error) {
            console.error("Erro ao adicionar nota:", error);
            showMessage('Erro ao adicionar nota', 'danger');
            throw error; // Propaga o erro para permitir tratamento
        }
    };

    const updateNota = async (nota) => {
        try {
            const payLoad = buildNotaPayload(nota);
            const result = await putData('/Nota', payLoad);
            setNotas(notas.map(n => n.id === nota.id ? result : n));
            showAlert('Nota atualizada com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao atualizar nota:", error);            
            showMessage(`Erro ao atualizar nota! ${error?.message || error}`, 'danger');
            throw error;
        }
    };

    const consultarEntradas = async (filtros = {}) => {
        return await fetchData('/Nota/Entradas', filtros);
    };

    const obterEntrada = async (notaId) => {
        return await fetchData(`/Nota/Entradas/${notaId}`);
    };

    const atualizarEntrada = async (notaId, entrada) => {
        return await putData(`/Nota/Entradas/${notaId}`, entrada);
    };

    const excluirEntrada = async (notaId, justificativa) => {
        return await deleteData(`/Nota/Entradas/${notaId}`, {}, { justificativa });
    };

    const buscaNotaByOrdemServico = async (ordemServicoId) => {
        try {
            return await fetchData('/Nota/GetByOrdemServico', { ordemServicoId });
        } catch (error) {
            console.error("Erro ao buscar nota da ordem de serviço:", error);
            showMessage(`Erro ao buscar nota da ordem de serviço! ${error?.message || error}`, 'danger');
            return undefined;
        }
    };

    const deleteNota = async (id) => {
        try {
            await deleteData('/Nota', { notaId: id });
            setNotas(notas.filter(n => n.id !== id));
            showAlert('Nota excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir nota:", error);
            showMessage(`Erro ao excluir nota! ${error?.message || error}`, 'danger');
        }
    };

    return (
        <NotaContext.Provider value={{ 
            notas, notaSel, setNotaSel, 
            buscaNotaById, buscaNotaByChave, buscaNotaByOrdemServico,
            addNota, updateNota, deleteNota,
            consultarEntradas, obterEntrada, atualizarEntrada, excluirEntrada
        }}>            
            {children}
        </NotaContext.Provider>

    );
};
